import { RootState } from '../../index'
import { PATIENT_QUESTIONNAIRE_LOCALES } from '../../../types/questionnaire'
import { ILangData } from '../../../types/locale'

interface QuestionnaireLocales {
	[key: string]: string
}

export const selectLocales = (state: RootState): ILangData =>
	state.locale.langData

export const selectQuestionnaireLocales = (
	state: RootState
): QuestionnaireLocales => {
	const questionnaireLocales: QuestionnaireLocales = {}

	for (const key in PATIENT_QUESTIONNAIRE_LOCALES) {
		const locValue = state.locale.langData[key]

		if (!locValue) continue

		questionnaireLocales[key] = locValue
	}

	return questionnaireLocales
}
